module.exports = __webpack_public_path__ + "static/media/home.2738f334.jpg";